export { EditArticleProductTypeModal } from "./edit-article-product-type-modal";
